import styled from "styled-components";
import {media} from "../../../theme";

export const EulaConsentCard = styled.div`
    width: 100%;
    max-width: 1000px;
    padding: 24px;
    background: ${({theme}) => theme.palette.background.paper};
    border: 1px solid ${({theme}) => theme.palette.dividers.subtle};
    border-radius: 40px;

    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 2rem;

    ${media.sm} {
        padding: 32px;
    }

    ${media.md} {
        padding: 40px;
    }
`;

export const EulaCaptionsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    gap: 1rem;
`;

export const EulaConsentActionButtons = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: flex-end;
    justify-content: flex-end;
    gap: 1rem;
`;